import React from "react";
import { CloseTransferFormAutomated } from "./CloseTransferFormAutomated";
import { CloseTransferFormLegacy } from "./CloseTransferFormLegacy";
import { useCloseTransferFormProps } from "./useCloseTransferFormProps";

export const CloseTransferForm: React.FC = () => {
  const { isLegacy } = useCloseTransferFormProps();

  if (isLegacy) {
    // TODO this can be prunged after migration
    return <CloseTransferFormLegacy />;
  } else {
    return <CloseTransferFormAutomated />;
  }
};
